import { Component, Input, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/layout/layout.service';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-popup-message',
  templateUrl: './popup-message.component.html',
  styleUrls: ['./popup-message.component.scss']
})
export class PopupMessageComponent implements OnInit {
  @Input() data: any;
  isScrolable = false;
  confirmationMessage: string;
  constructor(public ls: LayoutService, public ps: PopupService) { }

  ngOnInit(): void {
    this.confirmationMessage = this.data[0].confirmationMessage;
    this.isScrolable = this.data[0].isScrolable;
  }

}
